import React, { useState, useEffect, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { ApiContext } from '../../../App';
import { getOrder } from '../../../lib/actions/orders';
import Loading from '../../shared/Loading';
import OrderInfoSlider from './OrderInfoSlider';
import OrderOverview from './OrderOverview';
import OrderVolumeDetails from './OrderVolumeDetails';
import NavButton from '../../shared/NavButton';
import NoDataError from '../../shared/NoDataError';
import PSTable from './payment_schedule_table/PSTable';
import TransactionsTable from './transactions_table/TransactionsTable';
import useOrderDependencies from '../../../hooks/useOrderDependencies';

export default function OrderDetail({ hit }) {
  const api = useContext(ApiContext);
  const [orderID, setOrderID] = useState();

  const resize = (arr, newSize, defaultValue) => {
    if (arr && arr.length)
      return [
        ...arr,
        ...Array(Math.max(newSize - arr.length, 0)).fill(defaultValue),
      ];
    return [];
  };

  const {
    data: order,
    error: orderError,
    isLoading: orderLoading,
  } = useQuery({
    queryKey: ['orders', orderID],
    queryFn: () => getOrder(api, orderID),
    enabled: !!orderID,
    retry: false,
  });

  useEffect(() => setOrderID(hit.id), [hit]);

  const {
    orderProps: {
      type,
      entity,
      errors,
      hasErrors,
      isLoading,
      paymentSchedule,
      transactions,
    },
  } = useOrderDependencies(order);

  const buildLinkPath = () => {
    if (type === 'account') {
      return `/accounts/${entity?.id}`;
    }
    return `/companies/${entity?.id}`;
  };

  if (orderError) return <NoDataError tag="Order" />;

  return (
    <div>
      {(orderLoading || isLoading) && !hasErrors ? (
        <Loading className="w-14 h-14" />
      ) : (
        <>
          <div className="flex items-center my-4">
            {!entity ? (
              <div className="my-4">
                <NavButton path="/" buttonText="Back to Search" />
              </div>
            ) : (
              <div className="my-4 flex gap-2">
                <NavButton
                  path={`${buildLinkPath()}?content=dashboard`}
                  buttonText={`${type} Dashboard`}
                />
                <NavButton
                  path={`${buildLinkPath()}?content=loans`}
                  buttonText={`${type} Loans`}
                />
              </div>
            )}
          </div>
          <OrderOverview
            order={order}
            product={order?.product}
            entity={entity}
          />
          <OrderVolumeDetails order={order} product={order?.product} />
          <OrderInfoSlider
            order={order}
            product={order?.product}
            entity={entity}
          />
          <div className="flex items-center justify-between">
            <div className="w-[41%] mr-4">
              <PSTable
                payment_schedule={resize(paymentSchedule, 5, {})}
                err={errors.psError}
              />
            </div>
            <div className="w-[59%] ml-4">
              <TransactionsTable
                transactions={resize(transactions, 5, {})}
                err={errors.transactionsError}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
